<template>
    <!-- 会员管理－会员用户管理 -->
    <div class="member-list">
        <content-view v-show="$utils.renderWhen(this,'memberUser')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="vip-form">
                <a-form-item label="ID">
                    <a-input placeholder="请输入" v-decorator="['id']" @pressEnter="search"></a-input>
                </a-form-item>
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search"></a-input>
                    <!-- <a-input placeholder="请输入" v-decorator="['phone', {rules: [{required: true, message: '请输入会员手机号'}]}]"></a-input> -->
                </a-form-item>
                <a-form-item label="会员名称">
                    <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['state']" @select="search">
                        <a-select-option :value="1">使用中</a-select-option>
                        <a-select-option :value="2">已拉黑</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="会员等级">
                    <a-select allowClear :options="allGradeList" placeholder="请选择" v-decorator="['gradeId']" @select="search"></a-select>
                </a-form-item>
                <a-form-item label="会员标签">
                    <a-select allowClear mode="multiple" :options="plainOptions" placeholder="请选择" v-decorator="['labelIds']"></a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <template slot="extra">
                    <a-button v-if="getBtnByAuth('depositsUpdate')" type="primary" @click="openModalDeposits" disabled>储值修改</a-button>
                    <a-button v-if="getBtnByAuth('storeUpdate')" type="primary" @click="openModal" disabled>积分修改</a-button>
<!--                    <a-button v-if="getBtnByAuth('sendCoupon')" type="primary" @click="openModalSendNewCoupon" disabled>新优惠券发放</a-button>-->
                </template>
<!--                <a-table :scroll="{y: 560}" :loading="tableLoading" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio'}" bordered :dataSource="dataSource" @change="changePage" :columns="columns" :pagination="pagination" :rowKey="record => record.id">-->
                <a-table :scroll="{y: 560}" :loading="tableLoading" bordered :dataSource="dataSource" @change="changePage" :columns="columns" :pagination="pagination" :rowKey="record => record.id">
                    <template slot="labelList" slot-scope="labelList">
                        <template v-if="labelList.length > 0">
                            <a-tag v-for="item in labelList" :key="item.id" :color="item.color">
                                {{item.name}}
                            </a-tag>
                        </template>
                        <template v-else>--</template>
                    </template>
                    <span slot="state" slot-scope="text">{{['','使用中','已拉黑'][text]}}</span>
                    <span slot="emptyNum" slot-scope="num">{{num || 0}}</span>
                    <template slot="action" slot-scope="a,row,i">
                        <template v-if="getBtnByAuth('vipDetail')">
                            <a class="text-primary" @click="toVipDetail(row.id)">会员详情</a>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="getBtnByAuth('storeDetail')">
                            <a class="text-primary" @click="toStoreDetail(row.id)">积分详情</a>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="getBtnByAuth('storeState')">
                            <a-popconfirm
                                :title="'确定将该用户' + (row.state == 1 ? '拉黑吗' : '取消拉黑吗?')"
                                @confirm="confirm(row.id, row.state)"
                            >
                                <a class="text-primary">{{row.state == 1 ? '拉黑' : '取消拉黑'}}</a>
                                <a-divider type="vertical"/>
                            </a-popconfirm>
                        </template>
                        <template v-if="getBtnByAuth('memberOperationRecord')">
                            <a class="text-primary" @click="toMemberOperationRecord(row.id)">操作记录</a>
                            <a-divider type="vertical"/>
                        </template>
                        <!-- <span v-if="getBtnByAuth('memberOperationRecord')">
                            <a class="text-primary" @click="toGetUserActivity(row)">活动信息</a>
                            <a-divider type="vertical" />
                        </span> -->

                        <template v-if="getBtnByAuth('setUserSign')">
                            <a-popover
                                v-model="row.showCheckbox"
                                trigger="click"
                                :placement="i < 4 ? 'leftTop' : 'leftBottom'"
                                :autoAdjustOverflow="false"
                                overlayClassName="tags-popover"
                            >
                                <template slot="title">
                                    <div class="mt8"></div>
                                    <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
                                        全选
                                    </a-checkbox>
                                </template>
                                <template slot="content">
                                    <a-checkbox-group v-model="checkedList" @change="onChange">
                                        <template v-for="item in plainOptions">
                                            <div class="mb8">
                                                <a-checkbox :value="item.value">{{item.label}}</a-checkbox>
                                            </div>
                                        </template>
                                    </a-checkbox-group>
                                    <a-divider class="no-margin_bottom no-margin_top"></a-divider>
                                    <div class="mt8">
                                        <a-button @click="row.showCheckbox = false">取消</a-button>
                                        <a-button type="primary" @click="updateReport(row)">确定</a-button>
                                    </div>
                                </template>
                                <a class="text-primary" @click="openUpdateReport(row)">打标签</a>
                            </a-popover>
                        </template>
                    </template>
                </a-table>
                <a-modal
                    :visible="visibleUpdateDeposits"
                    title='储值修改'
                    @cancel="visibleUpdateDeposits = false; updateDepositsForm.resetFields();"
                    @ok="handleUpdateDeposits"
                    :confirmLoading="confirmLoading"
                    :width="540"
                    >
                    <div class="in_title">
                        <a-icon type="info-circle" />
                        已选择 {{idList.length}} 位会员
                    </div>
                    <a-form :form="updateDepositsForm">
                        <a-form-item label="操作" :labelCol="{span: 6}" :wrapperCol="{span: 18}" >
                            <a-radio-group name="type" v-decorator="['changeType',{initialValue: 1}]">
                                <a-radio :value="1">增储值</a-radio>
                                <a-radio :value="-1">减储值</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="储值数值" :labelCol="{span: 6}" :wrapperCol="{span: 18}" >
                            <a-input-number style="width:100%" :precision="2" placeholder="请输入" :min="0.01" :max="99999999" v-decorator="['num',{rules: [{required: true, message: '请输入加/减储值数值',}]}]" />
                        </a-form-item>
                        <remark :labelSpan="6" :wrapperSpan="18" operateCode="ModifyStoredValue" />
                    </a-form>
                </a-modal>
                <a-modal
                    :visible="visible"
                    title='积分修改'
                    @cancel="visible = false; formModel.resetFields();"
                    @ok="handleCreate"
                    :confirmLoading="confirmLoading"
                    >
                    <div class="in_title">
                        <a-icon type="info-circle" />
                        已选择 {{idList.length}} 位会员
                    </div>
                    <a-form :form="formModel">
                        <a-form-item label="操作" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-radio-group name="type" v-decorator="['changeType',{initialValue: 1}]">
                                <a-radio :value="1">增积分</a-radio>
                                <a-radio :value="-1">减积分</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="积分数值" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-input-number style="width:100%" :precision="0" placeholder="请输入" :min="1" v-decorator="['num',{rules: [{required: true, message: '请输入加/减分数值',}]}]" />
                        </a-form-item>
                        <remark :labelSpan="5" :wrapperSpan="19" operateCode="UpdatePoints" />
                    </a-form>
                </a-modal>
                <ticket-picker @closeModal="closeModal" tableType="radio" goodType="coupon" ref="ticketPicker" :couponList="newCouponsList" @confirmSelectTicket='handleCreateSendNewCoupon'>
                    <a-form class="mt16" :form="formNewCoupon">
                        <remark :labelSpan="2" :wrapperSpan="21" operateCode="SendCoupon" />
                    </a-form>
                </ticket-picker>
                <activityInfo ref="activityInfo"/>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import activityInfo from "@/components/modules/member/activity-user-info.component"
    import remark from '@/components/modules/platform/remark.component';
    import ticketPicker from "@/components/modules/platform/tickets-picker.component"

    export default {
    name: "memberUser",
    components: {
        remark,
        activityInfo,
        ticketPicker,
    },
    props: {},
    data() {
        const columns = [
        {
            title: "ID",
            dataIndex: "id"
        },
        {
            title: "会员手机号",
            dataIndex: "phone"
        },
        {
            title: "会员姓名",
            dataIndex: "name"
        },
        {
            title: "会员标签",
            dataIndex: "labelList",
            scopedSlots: { customRender: "labelList" }
        },
        {
            title: "会员等级",
            dataIndex: "gradeName"
        },
        {
            title: "剩余积分",
            dataIndex: "availablePoint",
            scopedSlots: { customRender: "emptyNum" }
        },
        {
            title: "已用积分",
            dataIndex: "usedPoint",
            scopedSlots: { customRender: "emptyNum" }
        },
        {
            title: "状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }];
        return {
            labelCol: {span: 5},
            wrapperCol: {span: 19},
            columns,
            tableLoading: false,
            confirmLoading: false,
            dataSource: [],
            // 会员等级下拉列表
            allGradeList: [],
            // 多选选中的数据列表
            idList: [],
            visible: false,
            visibleSendCoupon: false,
            visibleSendNewCoupon: false,
            ticketRewardList: [],
            newCouponsList: [],
            selectedRowKeys: [],
            couponId: '',
            type: 1,
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            visibleUpdateDeposits: false,

            checkedList: [],
            indeterminate: true,
            checkAll: false,
            plainOptions: [],
        };
    },
    computed: {},
    methods: {
        getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
        },
        toGetUserActivity(item) {
            this.$refs.activityInfo.open(item);
        },
        // 分页change
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },
        // 搜索条件重置
        handleReset () {
            this.form.resetFields();
            this.dataSource = [];
            this.getList()
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        // 获取会员等级下拉列表
        getallGradeList() {
            this.$api.member.allGradeList({}).then(res => {
                res.forEach(item => {
                    item.value = item.id;
                    item.label = item.name;
                });
                this.allGradeList = res;
            })
        },
        // 获取会员标签下拉列表
        findAllLabel() {
            this.$api.member.findAllLabel({}).then(res => {
                res.forEach(item => {
                    item.value = item.id;
                    item.label = item.name;
                });
                this.plainOptions = res;
            })
        },
        // 获取会员用户列表
        getList() {
            this.tableLoading = true;
            this.form.validateFields((err, values) => {
                if(err) return;
                this.$api.member.memberList({
                    body: {
                        ...values,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                }).then(res => {
                    this.tableLoading = false;
                    res.list.forEach(item => {item.showCheckbox = false})
                    this.pagination.total = res.total;
                    this.dataSource = res.list;
                    this.selectedRowKeys = [];
                    this.idList = [];
                    if(res.list.length == 1 && values.phone) {
                        this.selectedRowKeys[0] = res.list[0].id;
                        this.idList = res.list;
                    }
                });
            });
        },
        // 打开修改积分弹框，若未选中任何用户则不能打开
        openModal() {
            if(this.idList.length == 0) {
                this.$message.warning('请先勾选要修改积分的用户！', 2)
            }else {
                this.visible = true
            }
        },
        // 打开新优惠券发放弹框，若未选中任何用户则不能打开
        openModalSendNewCoupon() {
            if(this.idList.length == 0) {
                this.$message.warning('请先勾选要发放优惠券的用户！', 2)
            }else {
                this.$refs.ticketPicker.visible = true;
            }
        },
        // 保存修改后的积分
        handleCreate() {
            this.formModel.validateFields((err, values) => {
                if (err) {
                    return false;
                }
                const userId = this.idList.map(el => el.id)[0];
                const phone = this.idList.map(el => el.phone)[0];
                this.confirmLoading = true;
                this.$api.member
                .batchPoints({
                    body: {
                        ...values,
                        userId: userId,
                        phone: phone,
                    }
                })
                .then(res => {
                    this.$message.success('操作成功', 2)
                    this.formModel.resetFields();
                    this.visible = false;
                    this.confirmLoading = false;
                    this.getList()
                }).catch(err => {
                    this.confirmLoading = false;
                });
            });
        },
        // 获取新优惠券列表
        getNewCoupons(suitType, type) {
            this.$api.changeCode.queryNewCoupon().then(res => {
                res.forEach((item, index) => {
                    item.goodsType = 2;
                    item.value = item.id;
                });
                this.newCouponsList = res
            });
        },
        closeModal() {
            this.formNewCoupon.resetFields();
        },
        // 新优惠券发放
        handleCreateSendNewCoupon(coupon) {
            if (!coupon.length) {
                // this.$message.warning("请先选择优惠券")
                return;
            }
            let userList = this.idList.map(item => {
                return {
                    mobile: item.phone,
                    userId: item.id
                }
            })
            let couponDetail = coupon[0]
            this.formNewCoupon.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$api.changeCode.sendNewCoupon({
                        body: {
                            userList: userList,
                            couponId: couponDetail.id,
                            remarkCategoryCode: values.remarkCategoryCode,
                            remarkCategoryName: values.remarkCategoryName,
                            remark: values.remark,
                            operatorId: this.loginInfo.id,
                            operator: this.loginInfo.name,
                            changeType: 1,
                            grantNum: 1,
                            grantShowName: couponDetail.name
                        }
                    })
                    .then(res => {
                        this.formNewCoupon.resetFields();
                        this.$message.success('操作成功')
                        this.getList();
                        this.$refs.ticketPicker.closeModal();
                    }).catch(err => {
                    });
                }})
        },

        // 多选选中
        onSelectChange(selectedRowKeys,idList) {
            this.selectedRowKeys = selectedRowKeys;
            this.idList = idList;
        },

        // 跳转到会员账号详情页面
        toVipDetail(id) {
            this.$router.push({name: "vipDetail", params: {id: id}});
        },

        // 跳转到会员积分详情
        toStoreDetail(id) {
            this.$router.push({name: "storeDetail", query: {id: id}});
        },
        // 跳转到会员积分详情
        toMemberOperationRecord(id) {
            this.$router.push({name: "memberOperationRecord", query: {id: id}});
        },
        // 拉黑
        confirm(id, state) {
            this.$api.member[state === 1 ? 'block' : 'unblock']({
                params: {
                    userId: id
                }
            }).then(res => {
                this.$message.success('操作成功', 2);
                this.getList();
            })
        },
        /**
         * @openModalDeposits 储值修改
         */
        openModalDeposits() {
            if(this.idList.length == 0) {
                this.$message.warning('请先勾选要修改储值的用户！', 2);
            }else {
                this.visibleUpdateDeposits = true;
            }
        },
        // 保存修改后的储值
        handleUpdateDeposits() {
            this.updateDepositsForm.validateFields((err, values) => {
                if (err) {
                    return false;
                }
                const userId = this.idList.map(el => el.id)[0];
                const phone = this.idList.map(el => el.phone)[0];
                this.confirmLoading = true;
                this.$api.member
                .batchModifyAppUserStoredValue({
                    body: {
                        ...values,
                        userId: userId,
                        phone: phone,
                    }
                })
                .then(res => {
                    this.$message.success('操作成功', 2)
                    this.updateDepositsForm.resetFields();
                    this.visibleUpdateDeposits = false;
                    this.confirmLoading = false;
                    this.getList()
                }).catch(err => {
                    this.confirmLoading = false;
                });
            });
        },

        onChange(checkedList) {
            this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
            this.checkAll = checkedList.length === this.plainOptions.length;
        },
        onCheckAllChange(e) {
            let list = [];
            this.plainOptions.forEach(item => {
                list.push(item.value)
            })
            Object.assign(this, {
                checkedList: e.target.checked ? list : [],
                indeterminate: false,
                checkAll: e.target.checked,
            });
        },
        openUpdateReport(row) {
            this.dataSource.map(item => {item.showCheckbox = false; return item})
            this.checkedList = [];
            row.labelList.forEach(item => {
                this.checkedList.push(item.id)
            })
            this.indeterminate = !!this.checkedList.length && this.checkedList.length < this.plainOptions.length;
            this.checkAll = this.checkedList.length === this.plainOptions.length;
            row.showCheckbox = true;
        },
        updateReport(row) {
            this.$api.member.addUserLabel({
                body: {
                    labelIdList: this.checkedList,
                    userId: row.id,
                }
            }).then(res => {
                row.showCheckbox = false;
                this.$message.success('操作成功');
                this.getList();
            })
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.formModel = this.$form.createForm(this);
        this.formNewCoupon = this.$form.createForm(this);
        this.updateDepositsForm = this.$form.createForm(this);
        this.loginInfo = this.$userInfoTool.getUser();
    },
    created() {},
    mounted() {
        this.getallGradeList();
        this.getList();
        this.getNewCoupons();
        this.findAllLabel();
    }
};
</script>
<style lang="scss">
.member-list {
    .tags-popover {
        .ant-popover-inner {
            border-radius: 8px!important;
        }
    }
}
</style>
